import React, { forwardRef } from "react"
import styled from "styled-components"
import { styleTheme } from "../../../style/theme";

import { RadioInputPropsType } from "./RadioInput.types"

const Component = forwardRef<HTMLInputElement, RadioInputPropsType>(
  ({...props}, ref) => (
    <label className={props.className}>
      <input type="radio" value={props.value} {...props} ref={ref} />
      <span
        className={
          ` ${props.disabled ? 'disabled' : ''} `
        }
      >
        {props.label}
      </span>
    </label>
  )
)

export const RadioInput: React.FC<RadioInputPropsType> = styled(Component)`

  color: ${styleTheme.colors.black};
  font-weight: bold;

  > input + span {
    margin-left: 6px;
  }

  > input:checked + span {
    color: ${styleTheme.colors.teal.base};
  }

  @media screen and (max-width: 480px) {
    font-size: 14px;
  }

  .disabled {
    opacity: 0.5;
  }
`